// these properties will be available from anywhere via this.property
export const constants = {
    isTouch: "ontouchstart" in window ? function () {document.body.classList.add("touch"); return true;}() : function () {document.body.classList.add("no-touch"); return false;}(),
    body: $("body")
};



export function navFunction() {
    let windowScroll;
    let windowW = $(window).outerWidth();
    let navBlock = $(".nav");

    $(window).on("load resize", function () {
        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty("--vh", `${vh}px`);

        windowW = $(window).outerWidth();

        if(windowW >= 1200) {

            if (navBlock.hasClass("show-nav")) {
                navBlock.removeClass("show-nav");
                $(".hamburger").removeClass("open");
            }
        }
    });
    $(window).on("load resize scroll", function () {
        windowScroll = $(window).scrollTop();
        windowW = $(window).outerWidth();
        let header = $(".header");
        if (windowScroll > 0) {
            header.addClass("scrolled");
        }
        if (windowScroll <= 0) {
            header.removeClass("scrolled");
        }
    });
    $(".sub-toggle").on("click", function () {
        if(windowW < 1200 ){
            $(this).parents("li").toggleClass("active");
            $(this).parents("li").find("ul").stop(true,true).slideToggle();
        }
    });

    $(".hamburger").on("click", function () {
        $(this).toggleClass("open");
        navBlock.toggleClass("show-nav");
        $("body").toggleClass("scroll-lock");
    });

}



// WEBPACK FOOTER //
// ./assets/js/modules/module.js